<template>
  <div>
    <printBase ref="LinkQR027" :title='title' :width='800'  :page='page'>
      <div v-for='(item,i) in goodsList' :key="i" :slot="page==1? 'content' : `content${i+1}`" class="printContainer">
        <h1 style='text-align:center'>{{storeName}}配送药品交接单</h1>
        <div style='text-align:right'>编号:{{orderInfo.saleOrder.orderNo}}</div>
        <table border='1' border-spacing='0'>
          <tr>
            <td style='width:100%' colspan="4" class='grayBg'>
              <span>
                配送信息（此部分由药房工作人员事先填写）
              </span>
            </td>
          </tr>
          <tr>
            <td style='width:33%'>
              <span>药品名称:{{item.saleOrderDetail.approvedDrugNames}}</span>
            </td>
            <td style='width:33%' colspan="2">
              <span>规格:{{item.saleOrderDetail.specifications}}</span>
            </td>
            <td style='width:33%'>
              <span>
                药品批号:{{item.saleOrderDetail.goodsLot}}
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span>单价（元）:{{item.saleOrderDetail.realPrice}}</span>
            </td>
            <td colspan="2">
              <span>数量:{{item.saleOrderDetail.goodsCount}}</span>
            </td>
            <td>
              <span>
                金额（元）:{{item.saleOrderDetail.amountDisplay}}
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <span>调配人:{{salePrescription&&salePrescription.allocaterName}}</span>
            </td>

            <td>
              <span>
                复核人:{{salePrescription&&salePrescription.reviewerName}}
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <span>送货时间:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span v-if="saleExpress&&saleExpress.expressTime" class="timeFormat">
                <span>{{saleExpress.expressTime.substr(0,4)}}&nbsp;&nbsp;&nbsp;&nbsp;年</span>
                <span>{{saleExpress.expressTime.substr(5,2)}}&nbsp;&nbsp;&nbsp;&nbsp;月</span>
                <span>{{saleExpress.expressTime.substr(8,2)}}&nbsp;&nbsp;&nbsp;&nbsp;日</span>
                <span>时</span>
              </span>
              <span v-else class="timeFormat">
                <span>年</span>
                <span>月</span>
                <span>日</span>
                <span>时</span>
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <span class="addressInline">送货地址:
                <span :class="{'address':saleExpress.address.length>80}">
                  {{saleExpress&&saleExpress.address}}
                </span>
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span>收货人姓名:{{saleExpress&&saleExpress.name}}</span>
            </td>
            <td colspan="2">
              <span>收货人联系方式:{{saleExpress&&saleExpress.phone}}</span>
            </td>
            <td>
              <span class='twoRow'>
                付款方式:{{proceedsStr}}
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span>配送人员姓名:{{saleExpress&&saleExpress.consignorName}}</span>
            </td>

            <td colspan="2">
              <span>
                贮藏要求:{{item.storageCondition}}
              </span>
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td colspan="4" class='grayBg'>
              <span>配送开始监控记录（由配送人员填写）</span>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <span>开始配送时间：</span>
              <span v-if="saleExpress&&saleExpress.transStartTime" class="timeFormat">
                <span>{{saleExpress.transStartTime.substr(0,4)}}&nbsp;&nbsp;&nbsp;&nbsp;年</span>
                <span>{{saleExpress.transStartTime.substr(5,2)}}&nbsp;&nbsp;&nbsp;&nbsp;月</span>
                <span>{{saleExpress.transStartTime.substr(8,2)}}&nbsp;&nbsp;&nbsp;&nbsp;日</span>
                <span>时</span>
              </span>
              <span v-else class="timeFormat">
                <span>年</span>
                <span>月</span>
                <span>日</span>
                <span>时</span>
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <span>开始配送时温度：</span>
              <span class="temp">{{`${item.saleOrderDetail.temperatureStart}℃`}}</span>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <span>配送人员签名：</span>
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td colspan="4" class='grayBg'>
              <span>交接温度监控记录（以下由客户和配送人员共同确认）</span>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <span>客户签收时间： </span>
              <span class="timeFormat">
                <span>年</span>
                <span>月</span>
                <span>日</span>
                <span>时</span>
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span>客户签收时温度:</span>
              <span class="temp">℃</span>
            </td>
            <td colspan="2">
              <span>药品包装是否完好:</span>
            </td>
            <td>
              <span>
                数量是否准确:
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span>在途温度记录是否正常:</span>
            </td>
            <td colspan="2">
              <span>药品外观形状是否正常:</span>
            </td>
            <td>
              <span>
                发票内容是否正确:
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span>配送人员签名:</span>
            </td>

            <td colspan="2">
              <span class='twoRow'>
                发票号:{{invoiceCode}}
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <span class="heightRow">
                客户签名确认:
              </span>
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td colspan="4" class='grayBg'>
              <span>如果您购买的是冷藏药品，请认真阅读以下内容：</span>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <span class='inline'> &nbsp;&nbsp;冷链药品一般属于生物制品，必须在 2~8
                ℃的环境下贮藏和运输，温度过高或过低都会破坏药物分子结构，影响药效发挥，严重时甚至引发毒性变异危及患者生命；在领取药品时，您需要携带药品保温箱及符合要求的冰袋，确保途中药品温度全程控制在
                2-8 °C范围内；到家或到院后，请立即将药品放入冰箱冷藏（2-8°C），切勿放置冷冻或零度保鲜层，使用时请严格按药品说明书操作。
               <br/> &nbsp;&nbsp;请您确认所购药品质量状况（包装是否完好、数量是否准确等），发票内容是否一致。 </span>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <span>□我已阅读并知晓。 客户签名确认：</span>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <span>尊敬的客户：</span>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <span class='inline'>
                &nbsp;&nbsp;您好！由于外送药品的特殊性，按药监部门相关规定，必须付清药款后方可拆开包装验药。请确认收到的药品，并查看包装是否完好，有无污损痕迹，温度是否符合要求，发票内容是否正确。此外，由于此类药品价格昂贵，储存条件较为苛刻，请患者慎重考虑购买的数量从而避免可能造成的不必要的损失，本药店对于此类药品将拒绝退货，敬请谅解，谢谢！如有疑问请致电：
              {{storePhone}} 祝早日康复！</span>
            </td>
          </tr>
        </table>
      </div>
    </printBase>
  </div>
</template>

<script>
import printBase from './printBase.vue';
import utils from '../../libs/utils.js';

export default {
  name: 'LinkQR27',
  components: {
    printBase,

  },
  props: {
    orderInfo: {

    },
  },
  computed: {
    page() {
      if (!this.orderInfo) {
        return 1;
      }
      return this.orderInfo.goodsList.length;
    },
    storePhone() {
      return this.$store.state.storeInfo.phone;
    },
    storeName() {
      return this.orderInfo.saleOrder.storeName;
    },


    // proceedsStr() {
    //   console.log(this.orderInfo.proceedsList.map(item => item.proceedsTypeName));
    //   return
    // },
  },
  data() {
    return {
      proceedsStr: '',
      title: 'Link-QR-027',
      salePrescription: {},
      saleExpress: {},
      goodsList: [],
      invoiceCode: '',
    };
  },
  methods: {
    print() {
      this.goodsList = this.orderInfo.goodsList;
      this.salePrescription = this.orderInfo.salePrescription;
      this.saleExpress = this.orderInfo.saleExpress || {};
      const keyList = ['provinceName', 'cityName', 'countyName', 'address'];
      let allAddress = '';
      for (const key in keyList) {
        allAddress += this.saleExpress[keyList[key]] || '';
      }
      this.saleExpress.address = allAddress;
      if (this.saleExpress.expressTime) {
        this.saleExpress.expressTime = utils.formatTime(this.saleExpress.expressTime, 'YYYY年MM月DD日');
      }
      this.saleExpress.transStartTime && (this.saleExpress.transStartTime = utils.formatTime(this.saleExpress.transStartTime, 'YYYY年MM月DD日'));
      this.proceedsStr = this.orderInfo.proceedsList.map(item => item.proceedsTypeName).join(',');
      this.invoiceCode = '';
      if (this.orderInfo.financeInvoiceVoList && this.orderInfo.financeInvoiceVoList[0] && this.orderInfo.financeInvoiceVoList[0].financeInvoice) {
        this.invoiceCode = this.orderInfo.financeInvoiceVoList[0].financeInvoice.code;
      }
      this.$nextTick(() => {
        this.$refs.LinkQR027.handlePrint();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.grayBg{
  background: #ccc
}
.printContainer{

  table{
    border-collapse:collapse;
}
 td,th{
   border: 1px solid #000;
    // text-align: center;
    // position: relative;
    // border-color: #000;
    // font-weight: 300;
    word-break: break-all;
    padding: 2px 6px;
    // font-size: 12px;
    >*{
        display: inline-block;
      height: 28px;
      // max-height: 32px;
      line-height: 28px;
      overflow:hidden
    }
    .twoRow{
      height: auto;
      max-height:56px
    }
    .inline{
      line-height: 28px;
      display: inline;
    }
    .timeFormat{
      >span{

        display: inline-block;
      width: 80px;
      text-align:right
      }
    }
    .temp{
      width: 100px;
      text-align:right;
    }
    .address {
      font-size: 12px;
    }
    .addressInline {
      display: inline;
    }

  }
}
</style>
